<div class="row" [ngClass]="analytics.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <div class="col-md-12">
    <div class="d-flex justify-content-between mt-2">
      <h6 class="quicksand-bold-label calendar-date">Global Pacing Plan</h6>

      <div *ngIf="!storageService.detectMob()">
        <button
          nbButton
          aria-label="Example icon button with a home icon"
          (click)="openAddPacingPlanDialog('add')"
          class="add-classroom-btn quicksand-bold-label text-capitalize"
          [disabled]="!addPacingPlanForm.valid"
        >
          <nb-icon icon="plus-outline"></nb-icon>
          Add Pacing Plan
        </button>

        <span class="delete-pacing-plans ml-3 cursor-pointer" (click)="openDeletePlanModal(dialog)" *ngIf="pacingPlans && pacingPlans.length > 0">
          <img src="/assets/icons/delete.svg" alt="delete-icon" height="20" width="20" />
        </span>
      </div>
    </div>
    <hr *ngIf="storageService.detectMob()" />

    <div>
      <form
        [formGroup]="addPacingPlanForm"
        class="mt-3 d-flex"
        [ngClass]="{
          row: storageService.detectMob()
        }"
      >
        <div
          class="form-group"
          [ngClass]="{
            'col-6 pr-1': storageService.detectMob(),
            'mr-3': !storageService.detectMob()
          }"
        >
          <mat-form-field appearance="outline" class="w-100 select-grade-subject">
            <mat-label>Select Grade</mat-label>
            <mat-select aria-label="Select Grade" formControlName="grade" (selectionChange)="getAllGlobalPacingPlans(true)">
              <mat-option *ngFor="let grade of grades" [value]="grade.id">
                {{ grade.grade }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="form-group"
          [ngClass]="{
            'col-6 pl-1': storageService.detectMob()
          }"
        >
          <mat-form-field appearance="outline" class="w-100 select-grade-subject">
            <mat-label>Select Subject</mat-label>
            <mat-select aria-label="Select Subject" formControlName="subject" (selectionChange)="getAllGlobalPacingPlans(true)">
              <mat-option *ngFor="let subject of subjects" [value]="subject.id">
                {{ subject.subject }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    </div>
    <!-- mobile view  -->
    <div class="d-flex justify-content-between" *ngIf="storageService.detectMob()">
      <button
        nbButton
        aria-label="Example icon button with a home icon"
        (click)="openAddPacingPlanDialog('add')"
        class="add-classroom-btn quicksand-bold-label text-capitalize"
        [disabled]="!addPacingPlanForm.valid"
        style="margin-top: -26px !important"
      >
        <nb-icon icon="plus-outline"></nb-icon>
        Add Pacing Plan
      </button>
    </div>
    <div *ngIf="!storageService.detectMob()">
      <table class="table table-hover mt-2 pacing-plan-table table-border-radius" *ngIf="pacingPlans.length > 0">
        <thead>
          <tr class="table-header-row-dark">
            <th scope="col" class="main-header">
              <mat-checkbox class="check-all" color="primary" [checked]="isCheckedAll" (change)="selectPacingPlans($event, 'all')"></mat-checkbox>
            </th>
            <th scope="col" class="main-header">Section Id</th>
            <th scope="col" class="main-header">Section Title</th>
            <th scope="col" class="main-header">Grade</th>
            <th scope="col" class="main-header">Subject</th>
            <th scope="col" class="main-header">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pacingPlan of pacingPlans" class="main-tr-content">
            <td>
              <mat-checkbox
                color="primary"
                class="example-margin mat-checkbox-color"
                (change)="selectPacingPlans($event, 'selectOne', pacingPlan.id)"
                [checked]="selectedPacingPlans.includes(pacingPlan.id)"
              ></mat-checkbox>
            </td>
            <td>{{ pacingPlan.section_id }}</td>
            <td>{{ pacingPlan.section_title }}</td>
            <td>{{ pacingPlan.grades.grade }}</td>
            <td>{{ pacingPlan.subject.subject }}</td>
            <td class="text-center">
              <nb-icon nbButtonIcon icon="more-vertical-outline" data-child="true" class="cursor-pointer ellipsis p-0" [matMenuTriggerFor]="matmenu"></nb-icon>

              <mat-menu #matmenu="matMenu" class="edit-btn-mat-menu">
                <button
                  mat-menu-item
                  (click)="
                    editGlobalPacingPlan(pacingPlan);
                    analytics.trackEvent(
                      '
                    Edit Global Pacing Plan',
                      ' Pacing Plan'
                    )
                  "
                >
                  <img _ngcontent-ng-c899988518="" src="/assets/icons/edit-note.svg" alt="edit-request" height="15" width="15" class="mb-1 img-dark" />
                  <label data-child="true" class="cursor-pointer alert-label ml-3 quicksand-bold-label">Edit</label>
                </button>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="storageService.detectMob()">
      <div class="cursor-pointer user-card" style="margin: 0 0 16px 0">
        <div class="d-flex" style="align-items: center; padding: 8px 15px; background-color: transparent !important">
          <mat-checkbox class="check-all" color="primary" [checked]="isCheckedAll" (change)="selectPacingPlans($event, 'all')"></mat-checkbox>
          <label class="select-all">Select All</label>
          <span class="delete-pacing-plans-mobile cursor-pointer ml-auto" (click)="openDeletePlanModal()" *ngIf="pacingPlans && pacingPlans.length > 0">
            <img src="/assets/icons/delete.svg" alt="delete-icon" height="18" width="18" />
          </span>
        </div>
      </div>
      <nb-card *ngFor="let pacingPlan of pacingPlans" class="cursor-pointer user-card">
        <nb-card-body class="row">
          <div class="col-12 mb-1 px-0 d-flex">
            <mat-checkbox
              color="primary"
              class="example-margin mat-checkbox-color mr-2"
              (change)="selectPacingPlans($event, 'selectOne', pacingPlan.id)"
              [checked]="selectedPacingPlans.includes(pacingPlan.id)"
              style="align-items: center"
            ></mat-checkbox>
            <label class="title">Section Id:</label>

            <label class="title-contents ml-4 expand-description"> {{ pacingPlan.section_id }}</label>
            <div class="d-flex align-items-start justify-content-end w-100">
              <nb-icon nbButtonIcon icon="more-vertical-outline" data-child="true" class="cursor-pointer ellipsis p-0" [matMenuTriggerFor]="matmenu"></nb-icon>
              <mat-menu #matmenu="matMenu" class="edit-btn-mat-menu">
                <button
                  mat-menu-item
                  (click)="
                    editGlobalPacingPlan(pacingPlan);
                    analytics.trackEvent(
                      '
                    Edit Global Pacing Plan',
                      ' Pacing Plan'
                    )
                  "
                >
                  <img _ngcontent-ng-c899988518="" src="/assets/icons/edit-note.svg" alt="edit-request" height="15" width="15" class="mb-1 img-dark" />
                  <label data-child="true" class="cursor-pointer alert-label ml-3 quicksand-bold-label">Edit</label>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="col-12 mb-1 px-0 d-flex">
            <label class="title ml-4">Section <br />Title:</label>
            <label class="title-contents expand-description" style="margin-left: 44px !important"> {{ pacingPlan.section_title }}</label>
          </div>
          <div class="col-12 mb-1 px-0 d-flex">
            <label class="title ml-4">Grade:</label>
            <label class="title-contents expand-description" style="margin-left: 48px !important"> {{ pacingPlan.grades.grade }}</label>
          </div>
          <div class="col-12 mb-1 px-0 d-flex">
            <label class="title ml-4">Subject:</label>
            <label class="title-contents expand-description" style="margin-left: 41px !important"> {{ pacingPlan.subject.subject }}</label>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="text-center" *ngIf="pacingPlans && pacingPlans.length === 0">
      <h6 class="quicksand-bold-label">No pacing plans Found!</h6>
    </div>
  </div>

  <div class="pagination d-flex justify-content-between bg-white w-100 p-3" *ngIf="currentPage !== 1 || pacingPlans.length > 0">
    <div>
      <span class="pagination-numbers-count quicksand-normal-label"> Page {{ currentPage }} of {{ totalPages }} </span>
      <br />
      <label class="quicksand-normal-label pagination-numbers-count"
        >Total Items : <b>{{ totalCount ? totalCount : 0 }}</b></label
      >
    </div>
    <div>
      <button class="btn-paginate mr-2" (click)="getPacingPlansWithPage(false); isCheckedAll = false" [disabled]="currentPage === 1" style="height: 40px">
        <label *ngIf="!storageService.detectMob()" class="mb-0"> Previous</label>
        <nb-icon icon="arrow-back-outline" *ngIf="storageService.detectMob()"> </nb-icon>
      </button>

      <nb-select
        placeholder="Select Page"
        class="mr-2"
        [(selected)]="currentPage"
        (selectedChange)="currentPage = $event; isCheckedAll = false; getAllGlobalPacingPlans()"
      >
        <nb-option [value]="page" *ngFor="let page of pages">{{ page }}</nb-option>
      </nb-select>

      <button class="btn-paginate" style="height: 40px" (click)="getPacingPlansWithPage(true); isCheckedAll = false" [disabled]="currentPage === totalPages">
        <label *ngIf="!storageService.detectMob()" class="mb-0"> Next</label>
        <nb-icon icon="arrow-forward-outline" *ngIf="storageService.detectMob()"> </nb-icon>
      </button>
    </div>
  </div>
</div>

<ng-template #pacingPlanDialog>
  <div [ngClass]="analytics.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <h6 class="quicksand-bold-label calendar-date text-center">Add Pacing Plan</h6>
    <div class="text-center">
      <label class="quicksand-normal-label select-grade-subject-instruction">Please select subject and grade!</label>
    </div>
    <form [formGroup]="addPacingPlanForm" class="mt-3">
      <div class="row" style="margin-bottom: -32px">
        <div class="col-md-6">
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>Select Grade</mat-label>
              <mat-select aria-label="Select Grade" formControlName="grade">
                <mat-option *ngFor="let grade of grades" [value]="grade.id">
                  {{ grade.grade }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>Select Subject</mat-label>
              <mat-select aria-label="Select Subject" formControlName="subject">
                <mat-option *ngFor="let subject of subjects" [value]="subject.id">
                  {{ subject.subject }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <hr />

      <div class="d-flex justify-content-end">
        <button
          nbButton
          class="cancel-add delete-lesson-plan bg-white bg-white-dark-mode m-2 w-100 quicksand-bold-label text-capitalize"
          (click)="dialog.closeAll()"
        >
          Cancel
        </button>
        <button
          nbButton
          color="warn"
          class="cancel-add add-pacing-plan m-2 w-100 quicksand-bold-label text-capitalize"
          [disabled]="addPacingPlanForm.invalid"
          (click)="addPacingPlan()"
        >
          Add
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #pacingPlan let-modal>
  <div class="add-classroom-modal add-pacing-plan-modal" [ngClass]="analytics.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="modal-header d-flex justify-content-between align-items-center w-100">
      <div class="d-flex align-items-center">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline"></nb-icon>
        </span>
        <h6 class="add-clasroom-text quicksand-bold-label m-0" style="color: #175cd3">Add Pacing Plan</h6>
      </div>

      <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="modalService.dismissAll(modalRef)">
        <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
      </span>
    </div>
    <div class="modal-body">
      <div class="text-start">
        <label class="quicksand-normal-label select-grade-subject-instruction">Please select subject and grade!</label>
      </div>
      <form [formGroup]="addPacingPlanForm" class="mt-3">
        <div class="" style="margin-bottom: -32px">
          <div>
            <div class="form-group">
              <label class="label form-control-label quicksand-normal-label lable-color-dark-mode">Select Grade <span class="required-field">*</span></label>
              <mat-select aria-label="Select Grade" formControlName="grade" class="form-fields" [disabled]="true">
                <mat-option *ngFor="let grade of grades" [value]="grade.id" class="quicksand-bold-label select-range">
                  {{ grade.grade }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div>
            <div class="form-group">
              <label class="label form-control-label quicksand-normal-label lable-color-dark-mode">Select Subject <span class="required-field">*</span></label>
              <mat-select aria-label="Select Subject" formControlName="subject" class="form-fields" [disabled]="true">
                <mat-option *ngFor="let subject of subjects" [value]="subject.id" class="quicksand-bold-label select-range">
                  {{ subject.subject }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer d-flex justify-content-end">
      <div class="d-flex justify-content-end">
        <button
          nbButton
          class="cancel-add delete-lesson-plan mr-2 bg-white bg-white-dark-mode w-100 quicksand-bold-label text-capitalize"
          (click)="modalService.dismissAll(modalRef)"
        >
          Cancel
        </button>
        <button
          nbButton
          color="warn"
          class="cancel-add add-pacing-plan w-100 quicksand-bold-label text-capitalize"
          [disabled]="addPacingPlanForm.invalid"
          (click)="addPacingPlan()"
        >
          Add Pacing Plan
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deletePacingPlanDialog>
  <div [ngClass]="analytics.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="text-center">
      <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
      <br />

      <label class="label-delete-lesson-plan mt-2 quicksand-bold-label">Delete Pacing Plan</label>
      <br />
      <label class="delete-lesson-plan-confirmation quicksand-normal-label"
        >Are you sure want to delete
        <span *ngIf="selectedPacingPlans && selectedPacingPlans.length === 0">all</span>
        <span *ngIf="selectedPacingPlans && selectedPacingPlans.length > 0">selected</span>
        pacing plan ?</label
      >
    </div>
    <div class="d-flex">
      <button nbButton class="delete-lesson-plan bg-white bg-white-dark-mode m-2 w-100 quicksand-bold-label text-capitalize cancel" (click)="dialog.closeAll()">
        Cancel
      </button>
      <button nbButton color="warn" class="delete-lesson-plan delete m-2 w-100 quicksand-bold-label text-capitalize" (click)="resetPacingPlan()">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #editModal>
  <div class="add-classroom-modal edit-global-pacing-modal" [ngClass]="analytics.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="modal-header d-flex align-items-center justify-content-between w-100">
      <div class="d-flex align-items-center">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline" class="plus-icon"></nb-icon>
        </span>
        <h6 class="add-clasroom-text quicksand-bold-label m-0">
          <span class="add-clasroom-text">Edit Global Pacing Plan</span>
        </h6>
      </div>

      <span
        class="icon-close-classroom-modal d-block cursor-pointer"
        (click)="modalService.dismissAll(editModal); analytics.trackEvent('Add New Item Request', 'Request')"
      >
        <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
      </span>
    </div>

    <div class="modal-body">
      <div class="py-2">
        <label class="label form-control-label quicksand-normal-label lable-color-dark-mode">Section Id</label>
        <input type="text" class="nb-input quicksand-normal-label input-name-dark" nbInput fullWidth [(ngModel)]="sectionId" placeholder="Section Id" />
      </div>
      <div class="py-2">
        <label class="label form-control-label quicksand-normal-label lable-color-dark-mode">Section Title</label>

        <textarea
          nbInput
          class="w-100 quicksand-normal-label text-area text-area-lg"
          mat-autosize="true"
          placeholder="Section Title"
          [(ngModel)]="sectionTitle"
        ></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <button
          nbButton
          class="cancel-add delete-lesson-plan mr-2 bg-cancel-btn cancel w-100 quicksand-bold-label text-capitalize"
          (click)="modalService.dismissAll(editModal)"
        >
          Cancel
        </button>

        <button nbButton color="warn" class="cancel-add add-pacing-plan w-100 quicksand-bold-label text-capitalize" (click)="updatePacingPlan()">Update</button>
      </div>
    </div>
  </div>
</ng-template>
